// src/pages/Accounting/Reports/AccountList/components/AddToMgmtReportsModal.tsx

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ChevronDown, Check } from 'lucide-react';

interface AddToMgmtReportsModalProps {
  open: boolean;
  onClose: () => void;
  onAdd: (group: string) => void;
  reportName: string;
}

export default function AddToMgmtReportsModal({ open, onClose, onAdd, reportName }: AddToMgmtReportsModalProps) {
  const [group, setGroup] = useState('monthly-financials');

  useEffect(() => {
    if (open) setGroup('monthly-financials');
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div onClick={onClose} className="fixed inset-0 z-[1000] bg-black/40 flex items-center justify-center p-4">
      <div onClick={(e) => e.stopPropagation()} className="bg-white border border-line rounded-xl shadow-2xl p-6 w-full max-w-[460px] text-center">
        <div className="w-12 h-12 rounded-full bg-[#E6F3EE] text-teal-dark inline-flex items-center justify-center mb-3.5">
          <Check size={24} strokeWidth={2} />
        </div>
        <h4 className="text-[17px] font-extrabold text-ink m-0 mb-1.5">Add {reportName} to Management reports?</h4>
        <p className="text-[13px] text-ink3 m-0 mb-4">
          This report will appear in your selected group for quick access.
        </p>

        <div className="text-left mb-4">
          <label className="block text-[11.5px] text-ink3 font-semibold mb-1.5">Group</label>
          <div className="relative">
            <select value={group} onChange={(e) => setGroup(e.target.value)} className="w-full bg-white border border-line rounded-md px-2.5 py-2 text-[12.5px] text-ink outline-none focus:border-teal-dark appearance-none cursor-pointer pr-8">
              <option value="monthly-financials">Monthly financials</option>
              <option value="quarterly-review">Quarterly review</option>
              <option value="year-end">Year-end</option>
            </select>
            <ChevronDown size={12} strokeWidth={2.5} className="text-ink3 absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-3 border-t border-lineSoft">
          <button type="button" onClick={onClose} className="text-ink3 text-[13px] font-bold px-4 py-2 border-none bg-transparent cursor-pointer hover:text-ink">
            Cancel
          </button>
          <button type="button" onClick={() => onAdd(group)} className="bg-teal-dark text-white text-[13px] font-bold px-5 py-2 rounded-md border-none cursor-pointer hover:brightness-110">
            Add
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}